import { Tab, useSetTab } from "@commonlibs";
import { useEffect } from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { RouteTabProps } from "./RouteTab.types";

const RouteTab = ({ to, index, children, ...restTabProps }: RouteTabProps): JSX.Element => {
    const { pathname } = useLocation();
    const setTab = useSetTab();

    useEffect(() => {
        if (matchPath({ path: to, caseSensitive: true }, pathname) || pathname.includes(to)) setTab(index);
    }, [pathname]);

    return (
        <Link type="router" to={to}>
            <Tab index={index} {...restTabProps}>
                {children}
            </Tab>
        </Link>
    );
};

export default RouteTab;
